module.exports = __webpack_public_path__ + "img/main_visual_bsa.aaaedc4b.jpg";